"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactLazyLoad = _interopRequireDefault(require("react-lazy-load"));
var _intl = require("@kyruus/intl");
var _Videocam = _interopRequireDefault(require("@kyruus/react-ikons/Videocam"));
var _imageComponent = require("@kyruus/image-component");
var _styles = require("./styles");
var _images = require("../../lib/images");
var _globals = require("../../lib/constants/globals");
var _messages = _interopRequireDefault(require("../../lib/constants/messages"));
var _providerProfileLink = _interopRequireDefault(require("../ProviderProfileLink/provider-profile-link"));
const ProviderImage = _ref => {
  let {
    provider,
    summaryCallback,
    summaryUrl,
    track,
    lazyLoadImg
  } = _ref;
  const {
    config: imageServiceConfig
  } = (0, _imageComponent.useImageService)();
  const ProviderImageWrapper = imageServiceConfig.enableEnhancement ? _styles.ProviderImageContainerWithEnhancement : _styles.ProviderImageContainer;
  return /*#__PURE__*/_react.default.createElement(_providerProfileLink.default, {
    provider: provider,
    pageSection: _globals.LOGGING.PAGE_SECTION.PROVIDER_IMAGE,
    navCallback: summaryCallback,
    navUrl: summaryUrl,
    track: track
  }, /*#__PURE__*/_react.default.createElement(ProviderImageWrapper, null, lazyLoadImg ? /*#__PURE__*/_react.default.createElement(_reactLazyLoad.default, {
    debounce: false,
    offsetVertical: 800
  }, /*#__PURE__*/_react.default.createElement(_styles.ProviderImg, {
    altText: provider.name?.full_name || '',
    id: `image${provider.id}`,
    src: (0, _images.getProviderImageUrl)(provider),
    itemProp: "image",
    width: 96,
    height: 96,
    enhancementEnabled: imageServiceConfig.enableEnhancement || false
  })) : /*#__PURE__*/_react.default.createElement(_styles.ProviderImg, {
    altText: provider.name?.full_name || '',
    id: `image${provider.id}`,
    src: (0, _images.getProviderImageUrl)(provider),
    itemProp: "image",
    width: 96,
    height: 96,
    enhancementEnabled: imageServiceConfig.enableEnhancement || false
  }), provider.provider_videos && !!provider.provider_videos.length && /*#__PURE__*/_react.default.createElement(_styles.ProviderVideoBanner, null, /*#__PURE__*/_react.default.createElement(_intl.FormattedMessage, _messages.default.hasvideo), /*#__PURE__*/_react.default.createElement(_Videocam.default, {
    size: "12px"
  }))));
};
var _default = exports.default = ProviderImage;
ProviderImage.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "ProviderImage"
};